import ShareListView from '@/components/detail/components/shared/parkinglotShare/components/shareList'

import type { TicketPhoto } from '@/api/dto/ticket'
import BottomSheet from '@/shared/components/BottomSheet'
import Portal from '@/shared/components/Portal'

interface ParkinglotShareBottomSheetProps {
  isOpen: boolean
  onClose: () => void
  type: string
  seq: number
  parkinglotName: string
  parkinglotAddress: string
  targetId?: string
  price?: number
  photo?: TicketPhoto
}

const ParkinglotShareBottomSheet = (props: ParkinglotShareBottomSheetProps) => {
  const { isOpen, onClose, targetId, ...shareListViewProps } = props
  return (
    <Portal targetId={targetId}>
      <BottomSheet
        isOpen={isOpen}
        disabled={false}
        btnText="닫기"
        title="주차장 정보를 공유해 보세요."
        onClick={onClose}
        bodyContent={<ShareListView {...shareListViewProps} />}
      />
    </Portal>
  )
}

export default ParkinglotShareBottomSheet
